// Description: Enum for play session types
enum PlaySessionTypes {
  PROGRESSION_SESSION = "PROGRESSION_SESSION",
  PRACTISE_SESSION = "PRACTISE_SESSION",
  CHALLENGE_SESSION = "CHALLENGE_SESSION",
  PRIVATE_SESSION = "PRIVATE_SESSION",
  PLAYLIST_SESSION = "PLAYLIST_SESSION",
};

export default PlaySessionTypes;